import { latestMovies } from '@/mocks/homeData';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function LatestMovies() {
  return (
    <section id="latest" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="最近上新"
          title="金桔影院最新电影 · 近一周上线"
          desc="按上线时间倒序整理的近期新片，标题与短摘要优先，方便你一眼扫过再决定要不要深入看。"
          actionLabel="接收上新提醒"
        />

        <div className="mt-8 overflow-hidden rounded-xl border border-background-200 bg-background-50">
          {latestMovies.map((item, index) => (
            <article
              key={item.id}
              className={`group flex flex-col gap-3 px-5 py-5 md:flex-row md:items-center md:justify-between md:gap-6 transition hover:bg-primary-50/60 ${
                index !== 0 ? 'border-t border-background-200' : ''
              }`}
            >
              <div className="md:flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">{item.title}</h3>
                  <span className="rounded-md bg-background-100 px-2 py-0.5 text-[11px] text-foreground-600">{item.genre}</span>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
              </div>
              <div className="flex items-center gap-5 md:gap-6 md:shrink-0">
                <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-calendar-line text-sm"></i>
                  </span>
                  上线 {item.date}
                </span>
                <span className="inline-flex items-center gap-1 text-sm font-semibold text-accent-600">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-sm"></i>
                  </span>
                  {item.score}
                </span>
                <span className="w-8 h-8 flex items-center justify-center rounded-full border border-background-300 text-foreground-500 transition group-hover:border-primary-400 group-hover:text-primary-600">
                  <i className="ri-arrow-right-up-line text-base"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}